import * as React from 'react';
import { SelectMultipleHierarchy } from 'app/area/shared/translated-components';
import { SearchFiltersTranslation } from '../constants';
import { FilterCommonTypes } from '../types-store';
import { FilterPanel } from './filter-panel';
import { PredefinedIds, FilterCommonValues, PredefinedFilter, PredefinedFilterType } from './types';
import { FilterMeatballMenu } from 'app/area/search-filters/filters/filter-meatball-menu';
import styles from './filter-predefined.scss';

interface FilterPredefinedProps {
  includeValues: FilterCommonValues<FilterCommonTypes>[];
  excludeValues: FilterCommonValues<FilterCommonTypes>[];
  predefinedFilters: PredefinedFilter;
  onChange: (id: string, values: FilterCommonValues<number>[]) => void;

  open: boolean;
  openCloseFilter: (id: string, open: boolean) => void;

  translation: SearchFiltersTranslation;
  locale: string;
}

interface FilterPredefinedState {
  query: string[];
}

const emptyList = [];

export class FilterPredefined extends React.PureComponent<FilterPredefinedProps, FilterPredefinedState> {

  public state: Readonly<FilterPredefinedState> = {
    query: []
  };

  private onClear = () => {
    const { onChange } = this.props;

    onChange(PredefinedIds.include, undefined);
    onChange(PredefinedIds.exclude, undefined);
  }

  private onChangeInclude = (values: FilterCommonValues<number>[]) => {
    this.props.onChange(PredefinedIds.include, values);
  }

  private onChangeExclude = (values: FilterCommonValues<number>[]) => {
    this.props.onChange(PredefinedIds.exclude, values);
  }

  private loadOptions = (options: { query: string }) => {
    this.setState({
      query: options.query && options.query
        .split(' ')
        .map(s => s.trim().toLowerCase())
        .filter(s => s)
        || emptyList
    });
  }

  public render() {

    const { includeValues, excludeValues, predefinedFilters, translation, locale, open, openCloseFilter } = this.props;

    const displayExclude = predefinedFilters?.type === PredefinedFilterType.includeExclude;

    const filteredOptions = (this.state.query && this.state.query.length > 0
      ? predefinedFilters?.values?.filter(o => this.state.query.every(q => o.description.toLowerCase().indexOf(q) > -1))
      : predefinedFilters?.values) || emptyList;

    const normalizedIncludeValues = includeValues
      ? predefinedFilters?.values?.filter(option => includeValues.some(v => option.value === v.value)) || emptyList
      : emptyList;

    const normalizedExcludeValues = excludeValues
      ? predefinedFilters?.values?.filter(option => excludeValues.some(v => option.value === v.value)) || emptyList
      : emptyList;

    const count = normalizedIncludeValues.length + normalizedExcludeValues.length;

    return <FilterPanel
      id={PredefinedIds.filter}
      header={translation.filters_predefined_filters}
      count={count}
      open={open}
      openCloseFilter={openCloseFilter}>
      <FilterMeatballMenu
        id={PredefinedIds.filter}
        options={{ clear: true }}
        onClear={this.onClear}
        translation={translation}
        meatballClassName={styles.meatball}
      />
      <SelectMultipleHierarchy
        componentId={PredefinedIds.include}
        className={undefined}
        label={displayExclude ? { text: translation.filters_include } : undefined}

        valueItems={normalizedIncludeValues}
        onChange={this.onChangeInclude}

        options={filteredOptions.filter(o => !excludeValues || !excludeValues.some(v => o.value === v.value))}
        onLoadOptions={this.loadOptions}

        placeholder={translation && translation.search}

        displaySelectAll={true}
        locale={locale}
      />
      {displayExclude && <>
        <hr />
        <SelectMultipleHierarchy
          componentId={PredefinedIds.exclude}
          className={undefined}
          label={{ text: translation.filters_exclude }}

          valueItems={normalizedExcludeValues}
          onChange={this.onChangeExclude}

          options={filteredOptions.filter(o => !includeValues || !includeValues.some(v => o.value === v.value))}
          onLoadOptions={this.loadOptions}

          placeholder={translation && translation.search}

          displaySelectAll={true}
          locale={locale}
        />
      </>}
    </FilterPanel>;
  }
}
